import type { Product, ProductCategory, ProductTag } from '@/types/domain';

/**
 * Catalog mock data (temporary).
 *
 * No product has a price set (all `priceFrom: null`) — the UI shows a quote CTA.
 * This mock will be replaced by the Shop / backend catalog once connected.
 */

export const PRODUCT_CATEGORIES: ProductCategory[] = [
  { id: 'standard', labelKey: 'catalog.cat.standard' },
  { id: 'custom', labelKey: 'catalog.cat.custom' },
  { id: 'luxury', labelKey: 'catalog.cat.luxury' },
];

export const PRODUCT_TAGS: ProductTag[] = [
  { id: 'new', labelKey: 'catalog.tag.new' },
  { id: 'single', labelKey: 'catalog.tag.single' },
  { id: 'double', labelKey: 'catalog.tag.double' },
  { id: 'premium', labelKey: 'catalog.tag.premium' },
  { id: 'project', labelKey: 'catalog.tag.project' },
];

export const PRODUCTS: Product[] = [
  {
    id: 'p1',
    slug: 'aura-one',
    name: 'Aura One',
    descKey: 'catalog.p1.desc',
    category: 'standard',
    tags: ['single', 'premium'],
    capacity: 1,
    images: [
      'https://storage.helloreaddy.io/project_files/23cbf37b-3b60-45d6-b458-2fbb3e9ec10a/35545f0c-6d26-4bc5-b7a3-cf94caa69886_compressed_3.webp',
    ],
    priceFrom: null,
    purchasable: true,
  },
  {
    id: 'p2',
    slug: 'aura-duo',
    name: 'Aura Duo',
    descKey: 'catalog.p2.desc',
    category: 'standard',
    tags: ['double', 'premium'],
    capacity: 2,
    images: [
      'https://storage.helloreaddy.io/project_files/23cbf37b-3b60-45d6-b458-2fbb3e9ec10a/26556652-14bd-4784-93b0-8d2e327d2dd4_compressed_2.webp',
    ],
    priceFrom: null,
    purchasable: true,
  },
  {
    id: 'p3',
    slug: 'atelier-one',
    name: 'Atelier One',
    descKey: 'catalog.p3.desc',
    category: 'custom',
    tags: ['single', 'project', 'new'],
    capacity: 1,
    images: [
      'https://readdy.ai/api/search-image?query=Custom%20designed%20premium%20single%20car%20garage%20of%20a%20modern%20luxury%20villa%2C%20bespoke%20anthracite%20facade%20with%20vertical%20natural%20wood%20slats%20and%20warm%20gold%20accent%20lighting%2C%20minimalist%20architectural%20detail%2C%20soft%20evening%20light%2C%20high%20detail%2C%20professional%20editorial%20architectural%20photography&width=1200&height=800&seq=vg-atelier-one-01&orientation=landscape',
    ],
    priceFrom: null,
    purchasable: true,
  },
  {
    id: 'p4',
    slug: 'atelier-duo',
    name: 'Atelier Duo',
    descKey: 'catalog.p4.desc',
    category: 'custom',
    tags: ['double', 'project'],
    capacity: 2,
    images: [
      'https://readdy.ai/api/search-image?query=Custom%20designed%20premium%20double%20car%20garage%20of%20a%20luxury%20villa%20with%20bespoke%20facade%2C%20anthracite%20panels%2C%20natural%20wood%20details%20and%20warm%20gold%20architectural%20lighting%2C%20minimalist%20luxury%20aesthetic%2C%20dusk%20atmosphere%2C%20high%20detail%2C%20professional%20editorial%20architectural%20photography&width=1200&height=800&seq=vg-atelier-duo-01&orientation=landscape',
    ],
    priceFrom: null,
    purchasable: true,
  },
  {
    id: 'p5',
    slug: 'signature-duo',
    name: 'Signature',
    descKey: 'catalog.p5.desc',
    category: 'luxury',
    tags: ['double', 'premium'],
    capacity: 2,
    images: [
      'https://storage.helloreaddy.io/project_files/23cbf37b-3b60-45d6-b458-2fbb3e9ec10a/08b57743-7d7c-4a2a-9051-d88c4793a586_compressed_1.webp',
    ],
    priceFrom: null,
    purchasable: true,
  },
  {
    id: 'p6',
    slug: 'villa-project-series',
    name: 'Villa Project Series',
    descKey: 'catalog.p6.desc',
    category: 'luxury',
    tags: ['project', 'premium', 'new'],
    capacity: 'multi',
    images: [
      'https://storage.helloreaddy.io/project_files/23cbf37b-3b60-45d6-b458-2fbb3e9ec10a/3fc02ed0-655a-44a2-bdfe-be6f4b196b45_compressed_4.webp',
    ],
    priceFrom: null,
    purchasable: false,
  },
];